import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import FlatList from "flatlist-react";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const AdminContacts = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [born, setBorn] = useState("");
  const [familycode, setFamilycode] = useState("");
  const [contactlist, setContactlist] = useState([]);
  const [adding, setAdding] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [hasMember, setHasMember] = useState("");

  const [memberdata, setMemberdata] = React.useState({
    id: "",
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    age: "",
    dob: "",
    guardianrelation: "",
    guardianname: "",
    place: "",
    nickName: "",
    died: null,
    img: null,
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [addchild, setAddchild] = useState(false);

  const addChildHandler = (action) => {
    if (addchild === false) {
      setMemberdata({
        id: memberdata.id,
        firstName: "",
        lastName: "",
        gender: "",
        phone: "",
        age: "",
        dob: "",
        guardianrelation: "",
        guardianname: "",
        place: "",
        nickName: "",
        died: null,
        img: null,
      });
    } else {
      let result = contactlist.find((obj) => obj.id == memberdata.id);
      setMemberdata({
        id: result.id,
        firstName: result.firstName,
        lastName: result.lastName,
        gender: result.gender,
        phone: result.phone,
        age: result.age,
        dob: result.dob,
        guardianrelation: result.guardianrelation,
        guardianname: result.guardianname,
        place: result.place,
        nickName: result.nickName,
        died: result.died,
        img: result.died,
      });
    }
    setAddchild(!addchild);
  };
  const handleUpdateInfo = async (action) => {
    if (action == "Update" && adding == true) {
      const formData = new FormData();

      formData.append("familycode", familycode);
      formData.append("alias", memberdata.firstName);
      formData.append("surname", memberdata.lastName);
      formData.append("gender", memberdata.gender);
      formData.append("nickname", memberdata.nickName);
      formData.append("phone", memberdata.phone);
      formData.append("dob", memberdata.dob);
      formData.append("residance", memberdata.place);
      formData.append("img", memberdata.img);

      console.log(memberdata.img);
      const baseUrl = apilink.link;
      await axios
        .post(`${baseUrl}/family/rootmember`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })

        .then((response) => {
          console.log("Message" + response.data.message);

          if (response.data.message == "Saving successfull") {
            setMemberdata({
              id: "",
              firstName: "",
              lastName: "",
              gender: "",
              phone: "",
              age: "",
              dob: "",
              guardianrelation: "",
              guardianname: "",
              place: "",
              nickName: "",
              died: "",
              img: null,
            });
            setIsImageUploading(false);
            closeModal();
            toast.success("Saving successfull", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            return;
          }
        })
        .catch((error) => {
          setIsImageUploading(false);
          console.log(error.response.data.message);
        });
    }
    if (action == "Update" && adding == false) {
      if (addchild == true) {
        const formData = new FormData();

        formData.append("familycode", familycode);
        formData.append("parent", memberdata.id);
        formData.append("born", born);
        formData.append("alias", memberdata.firstName);
        formData.append("surname", memberdata.lastName);
        formData.append("gender", memberdata.gender);
        formData.append("nickname", memberdata.nickName);
        formData.append("phone", memberdata.phone);
        formData.append("dob", memberdata.dob);
        formData.append("residance", memberdata.place);
        formData.append("img", memberdata.img);

        console.log(memberdata.img);
        const baseUrl = apilink.link;
        await axios
          .post(`${baseUrl}/family/childmember`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })

          .then((response) => {
            console.log("Message" + response.data.message);

            if (response.data.message == "Saving successfull") {
              setMemberdata({
                id: "",
                firstName: "",
                lastName: "",
                gender: "",
                phone: "",
                age: "",
                dob: "",
                guardianrelation: "",
                guardianname: "",
                place: "",
                nickName: "",
                died: "",
                img: null,
              });
              setIsImageUploading(false);
              closeModal();
              toast.success("Saving successfull", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              return;
            }
          })
          .catch((error) => {
            setIsImageUploading(false);
            console.log(error.response.data.message);
          });
      } else {
        const formData = new FormData();

        formData.append("familycode", familycode);
        formData.append("id", memberdata.id);
        formData.append("born", born);
        formData.append("alias", memberdata.firstName);
        formData.append("surname", memberdata.lastName);
        formData.append("gender", memberdata.gender);
        formData.append("nickname", memberdata.nickName);
        formData.append("phone", memberdata.phone);
        formData.append("dob", memberdata.dob);
        formData.append("residance", memberdata.place);
        formData.append("img", memberdata.img);

        const baseUrl = apilink.link;
        await axios
          .post(`${baseUrl}/family/updatemember`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })

          .then((response) => {
            console.log("Message" + response.data.message);

            if (response.data.message == "Saving successfull") {
              setMemberdata({
                id: "",
                firstName: "",
                lastName: "",
                gender: "",
                phone: "",
                age: "",
                dob: "",
                guardianrelation: "",
                guardianname: "",
                place: "",
                nickName: "",
                died: "",
                img: null,
              });
              setIsImageUploading(false);
              closeModal();
              toast.success("Saving successfull", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              return;
            }
          })
          .catch((error) => {
            setIsImageUploading(false);
            console.log(error.response.data.message);
          });
      }
    }
    if (action == "Delete") {
      toast.success("Deleting", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  function openAddModal() {
    setAddchild(false);
    setAdding(true);
    setMemberdata({
      id: "",
      firstName: "",
      lastName: "",
      gender: "",
      phone: "",
      age: "",
      dob: "",
      guardianrelation: "",
      guardianname: "",
      place: "",
      nickName: "",
      died: "",
      img: null,
    });
    setModalIsOpen(true);
  }
  function openModal(id) {
    setAdding(false);
    setAddchild(false);
    let result = contactlist.find((obj) => obj.id == id);
    setMemberdata({
      id: result.id,
      firstName: result.alias,
      lastName: result.surname,
      gender: result.gender,
      phone: result.phone,
      age: result.age,
      dob: result.dob,
      guardianrelation: result.gender == "Female" ? "Daughter Of" : "Son Of",
      guardianname: result.parent == null ? "Root Member" : result.parent,
      place: result.residance,
      nickName: result.nickname,
      died: result.diedon == null ? "Alive" : "Died",
      img: result.img,
    });
    setModalIsOpen(true);
  }

  function closeModal() {
    setAddchild(false);
    setMemberdata({
      id: "",
      firstName: "",
      lastName: "",
      gender: "",
      phone: "",
      age: "",
      dob: "",
      guardianrelation: "",
      guardianname: "",
      place: "",
      nickName: "",
      died: null,
      img: null,
    });
    setModalIsOpen(false);
  }

  useEffect(() => {
    const getAsyncData = async () => {
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );
    
      setFamilycode(storedUser.familycode);
      setHasMember(storedUser.hasmember);
      //Get members from API

      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/members/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          console.log("Message" + response.data.records[0]);

          if (response.data.message == "Successfull") {
            setContactlist(response.data.records);
          }
        })
        .catch((error) => {
          setIsImageUploading(false);
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);

  const renderPerson = (person, idx) => {
    return (
      <div
        onClick={() => openModal(idx)}
        style={{ flexDirection: "column", marginBottom: "30px" }}
        key={idx}
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <b>
              {person.alias} {person.surname}
            </b>
            <h6 style={{ fontFamily: "Open Sans" }}>
              {person.parent != null && (
                <>{person.gender == "Female" ? "Daughter Of" : "Son Of"} </>
              )}
              {person.parent == null ? "Root Member" : person.parentname}
            </h6>
            {person.parent != null && (
              <>
                <h6 style={{ fontFamily: "Open Sans" }}>
                  Child Number: {person.born}
                </h6>
              </>
            )}
          </div>
          <div>
            <span style={{ fontFamily: "Open Sans" }}>{person.residance}</span>
            <br></br>
            <span className="float-end" style={{ fontFamily: "Open Sans" }}>
              {person.phone}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const onSearchInput = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <Modal
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            marginTop: "50px",
          },
          content: {
            backgroundColor: "#ffffff",
            color: "#EA6C82",
            left: "5%",
            right: "5%",
            height: "650px",
          },
          // content: {
          //   top: '50%',
          //   left: '50%',
          //   right: 'auto',
          //   bottom: 'auto',
          //   marginRight: '-50%',
          //   transform: 'translate(-50%, -50%)',
          // },
        }}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h2 style={{ fontFamily: "Open Sans", fontSize: 20 }}>Member Info</h2>

          <button
            style={{
              backgroundColor: "#EA6C82",
              borderRadius: 5,
              border: "none",
              height: 40,
              fontFamily: "Open Sans",
              paddingInline: 14,
              fontSize: 14,
              color: "white",
              width: "110px",
            }}
            onClick={closeModal}
          >
            Close Modal
          </button>
        </div>

        {adding == false && (
          <>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "14px",
              }}
            >
              <p
                style={{
                  fontFamily: "Open Sans",
                  fontSize: 14,
                  color: "#966919",
                }}
              >
                Edit, delete or add children
              </p>

              <button
                style={{
                  backgroundColor: "#966919",
                  borderRadius: 5,
                  border: "none",
                  height: 40,
                  fontFamily: "Open Sans",
                  paddingInline: 14,
                  fontSize: 14,
                  color: "white",
                  width: "110px",
                }}
                onClick={() => addChildHandler()}
              >
                {addchild ? "Update Info" : "Add Child"}
              </button>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              First Name(s)
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.firstName}
              onChange={(e) => {
                setMemberdata({ ...memberdata, firstName: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Surname
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.lastName}
              onChange={(e) => {
                setMemberdata({ ...memberdata, lastName: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Nickname (Optional)
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.nickName}
              onChange={(e) => {
                setMemberdata({ ...memberdata, nickName: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Phone
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.phone}
              onChange={(e) => {
                setMemberdata({ ...memberdata, phone: e.target.value });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>DOB</label>
            <br />
            <input
              type="date"
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.dob}
              onChange={(e) => {
                setMemberdata({ ...memberdata, dob: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Place of residence
            </label>
            <br />
            <input
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.place}
              onChange={(e) => {
                setMemberdata({ ...memberdata, place: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Gender
            </label>
            <br />
            <select
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={memberdata.gender}
              onChange={(e) => {
                setMemberdata({ ...memberdata, gender: e.target.value });
              }}
            >
              <option value=""></option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
          <div className="col-lg-3">
            <label
              for="files"
              style={{ fontFamily: "Open Sans", fontSize: 12 }}
            >
              Profile Picture
            </label>
            <br />
            <div
              className="input-group"
              style={{
                width: "100%",
              }}
            >
              <input
                id="files"
                name="files"
                style={{
                  width: "100%",
                  borderWidth: 1,
                  borderColor: "#EA6C82",
                  borderRadius: 5,
                  height: 50,
                  fontFamily: "Open Sans",
                  fontSize: 14,
                  paddingInline: 10,
                  marginBottom: "10px",
                }}
                type="file"
                onChange={(e) => {
                  setMemberdata({ ...memberdata, img: e.target.files[0] });
                }}
                className="form-control"
              />
              <span className="md-line"></span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3">
            <img
              alt="logo"
              style={{
                width: "100%",
                height: "220px",
                resizeMode: "stretch",
                border: "1px solid green",
                marginTop: "30px",
                borderRadius: "5px",
              }}
              src={
                memberdata.img == null
                  ? `https://familytree.artblueinternational.com/family-tree/public/images/members/temp1.png`
                  : `https://familytree.artblueinternational.com/family-tree/public/images/members/${memberdata.img}`
              }
            />
          </div>
          <div className="col-lg-3">
            {addchild === true && (
              <>
                <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
                  Child Number
                </label>
                <br />
                <input
                  style={{
                    width: "100%",
                    borderWidth: 1,
                    borderColor: "#EA6C82",
                    borderRadius: 5,
                    height: 50,
                    fontFamily: "Open Sans",
                    fontSize: 14,
                    paddingInline: 10,
                    marginBottom: "10px",
                  }}
                  type="number"
                  value={born}
                  onChange={(e) => {
                    setBorn(e.target.value);
                  }}
                />
              </>
            )}
          </div>
          <div className="col-lg-3">
            {adding == false && (
              <>
                {addchild == false && (
                  <>
                    <br />
                    <button
                      onClick={() => handleUpdateInfo("Delete")}
                      style={{
                        width: "100%",
                        backgroundColor: "#D70040",
                        borderRadius: 5,
                        border: "none",
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        color: "white",
                      }}
                    >
                      Delete Record
                    </button>
                  </>
                )}
              </>
            )}
          </div>
          <div className="col-lg-3">
            <br />
            <button
              onClick={() => handleUpdateInfo("Update")}
              style={{
                width: "100%",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                color: "white",
              }}
            >
              {isImageUploading === false && (
                <>
                  {" "}
                  {addchild
                    ? "Save New Child"
                    : adding
                    ? "Add New Member"
                    : "Update Member Info"}
                </>
              )}
              {isImageUploading && (
                <>
                  <Squares />
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>
          Family Members
        </p>
        <span style={{ fontFamily: "Open Sans" }}>{familycode}</span>
      </div>
      <div
        style={{
          width: "100%",
          height: 60,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <input
          placeholder={"Search . . ."}
          style={{
            width: hasMember == "Mo" ? "80%" : "100%",
            borderWidth: 1,
            borderColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            paddingInline: 10,
            marginBottom: "10px",
          }}
          value={searchTerm}
          onChange={onSearchInput}
        />
        {hasMember == "No" && (
          <>
            <button
              onClick={openAddModal}
              style={{
                width: "20%",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                marginLeft: "5px",
                fontFamily: "Open Sans",
                fontSize: 14,
                color: "white",
              }}
              className="float-right"
            >
              Add New
            </button>
          </>
        )}
      </div>

      <FlatList
        list={contactlist}
        renderItem={renderPerson}
        renderWhenEmpty={() => (
          <div>
            <p style={{ color: "gray", fontFamily: "Open Sans" }}>
              No items matching your search . . .
            </p>
          </div>
        )}
      
        sortBy={["level", { key: "level", descending: true }]}
        //   searchBy={["alias", "surname"]}
        //   searchTerm={searchTerm}
        search={{
          by: ["alias", "surname"],
          term: searchTerm,
          caseInsensitive: true,
        }}
        style={{ marginBottom: "300px" }}
      />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default AdminContacts;
